export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13674.7a1e04dc.jpg";